import React from 'react';
import { Dropdown, InputField } from '@makemydeal/dr-ui-bricks-components';
import type { IDropdownOption } from '@makemydeal/dr-ui-bricks-types';
import type { FuelSavingFormComponentProps, FuelSavingInputField } from '../types';
import { MILES_PER_OPTIONS, MILES_PER_WEEK, MILES_PER_MONTH, MILES_PER_YEAR } from '../utils';
import { useFieldValidation } from '../hooks';
import { FormField, FormGrid } from './FuelSavingAnalysis.styles';

export const FuelSavingForm: React.FC<FuelSavingFormComponentProps> = ({ values, onFieldChange, onMilesPerChange }) => {
    const selectedMilesPer = MILES_PER_OPTIONS.find((option) => option.value === values.milesPer) ?? MILES_PER_OPTIONS[0];
    const { fieldErrors, handleFieldChange } = useFieldValidation(onFieldChange);

    const renderInputField = (label: string, field: FuelSavingInputField, testId: string) => {
        const hasError = fieldErrors[field];

        return (
            <FormField key={field} className={hasError ? 'field-error' : ''}>
                <InputField
                    label={label}
                    name={field}
                    data-testid={testId}
                    value={values[field]}
                    onChange={(event) => handleFieldChange(field, event.target.value)}
                    inputMode="decimal"
                    type="text"
                />
            </FormField>
        );
    };

    return (
        <FormGrid>
            {renderInputField('New Vehicle MPG', 'newVehicleMpg', 'fuel-saving-input-new-vehicle-mpg')}
            {renderInputField('Trade-In MPG', 'tradeInMpg', 'fuel-saving-input-trade-in-mpg')}
            {renderInputField('New Vehicle Price per gallon', 'newVehiclePricePerGallon', 'fuel-saving-input-new-vehicle-price')}
            {renderInputField('Trade Price per gallon', 'tradePricePerGallon', 'fuel-saving-input-trade-price')}
            {renderInputField('Miles Driven', 'milesDriven', 'fuel-saving-input-miles-driven')}

            <FormField className="miles-per-field">
                <Dropdown
                    label="Miles Per"
                    name="milesPer"
                    data-testid="fuel-saving-dropdown-miles-per"
                    options={MILES_PER_OPTIONS}
                    value={selectedMilesPer}
                    onChange={(option: IDropdownOption) => {
                        if (
                            option.value === MILES_PER_WEEK ||
                            option.value === MILES_PER_MONTH ||
                            option.value === MILES_PER_YEAR
                        ) {
                            onMilesPerChange(option.value);
                        }
                    }}
                />
            </FormField>
        </FormGrid>
    );
};
